import {
  TGetProductContractHandoffReqDto,
  TGetProductContractHandoffResDto,
} from "@/api/services/main/product-contract/dtos/get-product-contract-handoff.dto";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";

/**
 * Resolves the contract the center staged under `oauth:contract:<contractToken>` for this hand-off.
 *
 * Authenticated, so it can only run once the session minted by the OAuth callback is persisted.
 * An unknown token is not an error — the center revokes every live token of a contract whenever
 * the contract changes, and the endpoint answers with `data: null`.
 */
export const getProductContractHandoffApi = async (req: TGetProductContractHandoffReqDto): Promise<TGetProductContractHandoffResDto> => {
  const url = createUrlWithParams("/product-contracts/handoff", req);
  const { data } = await clientApi.get<TGetProductContractHandoffResDto>(url);
  return data;
};
